import {useTranslation} from '@aboutyou/i18n';
import {
  ContentPopper,
  Flyout,
  GenericIconName,
  Icon,
  ModalDialog,
  SecondaryContentPopperButton,
  Text,
  useSizeRecommendationInfo,
} from '@aboutyou/ui-components';
import React from 'react';
import sc from 'styled-components';

export const SizeRecommendationInfo: React.FC = () => {
  const {t} = useTranslation();
  const {isOpen, cancel} = useSizeRecommendationInfo();

  return (
    <ContentPopper
      data-testid="sizeRecommendationInfo"
      open={isOpen}
      renderInPortal
      hideCloseButton
      LayoutComponent={process.env.STACK === 'desktop' ? ModalDialog : Flyout}
      onClose={cancel}
      headerContent={
        <InfoHeaderWrapper>
          <Icon
            asset={GenericIconName.Ruler}
            size={process.env.STACK === 'desktop' ? 'M' : 'S'}
          />
          <Text size="px16" weight="bold" textAlignment="center">
            {t('Why do we recommend this size for you?')}
          </Text>
        </InfoHeaderWrapper>
      }
      bodyContent={
        <Text>
          {t('This recommendation is based on your previous purchases.')}
        </Text>
      }
      footerContent={
        <SecondaryContentPopperButton label={t('Close')} onClick={cancel} />
      }
    />
  );
};

const InfoHeaderWrapper = sc.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 5px;

  > span {
    line-height: 1.3;
  }
`;
